import {
  TutorialDefinition,
  TutorialHighlightKey,
  TutorialId,
} from '../interfaces';
import { TUTORIAL_TEXT } from '../text';

export const teleportTutorial: TutorialDefinition = {
  id: TutorialId.Teleport,
  titleKey: 'guidedTutorial.teleport.title',
  steps: [
    {
      id: 'press-t',
      narration: TUTORIAL_TEXT.teleport.step1,
      keyHintLabel: 'T',
      awaitKeys: ['KeyT'],
    },
    {
      id: 'click-first-location',
      narration: TUTORIAL_TEXT.teleport.step2,
      highlightTarget: TutorialHighlightKey.TeleportFirstLocation,
      awaitClickSelector: '[data-testid="teleport-card-0"]',
    },
  ],
};
